<div class="p-fluid p-grid">
  <div class="p-col-12 p-sm-12 p-md-12 p-lg-3">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-fluid">
        <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Usuario" [restricao]="ds.restricoes.atributo('usuario.nome')"></m-restricao-string>
        <m-restricao-string label="Perfil" [restricao]="ds.restricoes.atributo('perfil.nome')"></m-restricao-string>
        <m-restricao-entidade label="Vigente" [restricao]="ds.restricoes.atributo('vigente')" [itens]="vigenteItens" itemId="value" itemLabel="label"></m-restricao-entidade>
        <m-restricao-entidade label="Origem" [restricao]="ds.restricoes.atributo('origem')" [itens]="origemItens" itemId="value" itemLabel="label"></m-restricao-entidade>
        <m-restricao-entidade label="Abrangência" [restricao]="ds.restricoes.atributo('abrangencia')" [itens]="abrangenciaItens" itemId="value" itemLabel="label"></m-restricao-entidade>
        <m-restricao-string label="Órg. de Justiça" [restricao]="ds.restricoes.atributo('orgaoJustica.nome')"></m-restricao-string>
        <m-restricao-string label="Fonte de dados" [restricao]="ds.restricoes.atributo('fonteDados.nome')"></m-restricao-string>
        <m-restricao-string label="Org. Colegiado" [restricao]="ds.restricoes.atributo('orgaoJulgadorColegiado.nome')"></m-restricao-string>
        <m-restricao-string label="Órg. Julgador" [restricao]="ds.restricoes.atributo('orgaoJulgador.nome')"></m-restricao-string>
        <m-restricao-entidade label="Nivel de sigilo" [restricao]="ds.restricoes.atributo('limiteNivelSigilo')" [itens]="nivelSigiloItens" itemId="value" itemLabel="label"></m-restricao-entidade>
      </div>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-col-12 p-sm-12  p-md-12 p-lg-9">
    <p-card header="Lista de permissões de usuários">
      <p-table
        [multiSortMeta]="ds.ordenacoes"
        [value]="ds.entidades"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortField="id"
        sortMode="multiple"
        responsiveLayout="scroll"
        styleClass="p-datatable-striped"
        emptyMessage="Nenhum registro encontrado">

        <ng-template pTemplate="header">
          <tr>
            <th class="p-text-center p-id" pSortableColumn="id">Id <p-sortIcon field="id"></p-sortIcon>
            </th>
            <th style="width: 200px">Usuário</th>
            <th pSortableColumn="vigente" style="width: 126px">Vigência <p-sortIcon field="vigente"></p-sortIcon>
            </th>
            <th>Permissão</th>
            <th pSortableColumn="origem" style="width: 120px">Origem <p-sortIcon field="origem"></p-sortIcon>
            </th>
            <th class="p-text-center p-action">Ação</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entidade>
          <tr>
            <td>{{entidade.id}}</td>
            <td>{{entidade.usuario.nome}}</td>
            <td>
              <span [ngClass]="entidade.vigente ? 'p-text-vigente' : 'p-text-encerrada'">{{ entidade.vigente ? 'Vigente' : 'Encerrada' }}</span>
            </td>
            <td>
              <div *ngIf="entidade.perfil" style="text-transform: capitalize;">{{ entidade.perfil.nome }}</div>
              <div>
                <span *ngIf="entidade.abrangencia === 'NACIONAL'"> Nacional </span>
                <span *ngIf="entidade.abrangencia === 'ORGAO_JUSTICA'">{{entidade.orgaoJustica.nome}}</span>
                <span *ngIf="entidade.abrangencia === 'FONTE_DADOS'">{{entidade.fonteDados.nome}}</span>
                <span *ngIf="entidade.abrangencia === 'ORGAO_JULGADOR_COLEGIADO'">
                  {{entidade.orgaoJulgadorColegiado.orgaoJustica.sigla}} - {{entidade.orgaoJulgadorColegiado.nome}}
                </span>
                <span *ngIf="entidade.abrangencia === 'ORGAO_JULGADOR'">
                  {{entidade.orgaoJulgador.orgaoJustica.sigla}} - {{entidade.orgaoJulgador.nome}}
                </span>
                -
                {{ getLimiteNivelSigiloDescricao(entidade.limiteNivelSigilo) }}
              </div>
              <div style="font-size: 0.8em; font-style: italic;">
                Iniciou em: {{entidade.inicio | date: 'dd/MM/yyyy HH:mm:ss'}}
                <span *ngIf="!!entidade.fim">
                  e terminou em: {{entidade.fim | date: 'dd/MM/yyyy HH:mm:ss'}}
                </span>
              </div>
            </td>
            <td class="p-text-center">
              <span *ngIf="entidade.origem === 'NATIVO'" class="p-nativo">Nativo</span>
              <span *ngIf="entidade.origem === 'CORPORATIVO'" class="p-corporativo">Corporativo</span>
            </td>
            <td>
              <a pButton [routerLink]="['/usuarioPermissao/edicao/', entidade.id]"
                icon="pi pi-search-plus"
                title="Visualizar" class="p-button-sm p-m-r-2">
              </a>
              <button pButton [disabled]="!entidade.vigente || entidade.origem === 'CORPORATIVO'"
                (click)="encerrarVigencia(entidade)" class="p-button-danger p-button-sm" icon="pi pi-times"
                title="Encerrar vigência">
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-6">
              <a pButton routerLink="/usuarioPermissao/novo" class="p-button-primary" label="Novo"></a>
            </div>
            <div class="p-field p-col-6 p-text-right">
              Quantidade de registros: <span class="p-text-bold">{{ds.total}}</span>
            </div>
          </div>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
